import React from 'react';
import { Link } from 'react-router-dom';

import NotFoundIcon from '../../assets/not_found.svg';

import * as S from './styles';

function NotFound() {
    return (
        <S.Container>
            <img src={NotFoundIcon} alt="not-found-icon" />
            <S.Messages>
                <S.Title>A página que você procura não está aparecendo.</S.Title>
                <S.Description>Vamos tentar outra vez? Volte para home e veja os serviços disponíveis!</S.Description>
                <Link to="/">
                    <S.StyledButton type="primary">Acessar home</S.StyledButton>
                </Link>
            </S.Messages>
        </S.Container>
    );
}

export default NotFound;
